import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Analytics } from '@vercel/analytics/react'
import './index.css'

import App from './App.tsx'
import { initMonitoring, initWebVitals } from './lib/monitoring'
import { queryClient } from './lib/queryClient'

// Initialize monitoring and performance tracking
initMonitoring();
initWebVitals();

// Apply saved theme before first render to avoid flash
const savedTheme = localStorage.getItem('pulse-theme');
if (savedTheme === 'dark') {
  document.documentElement.setAttribute('data-theme', 'dark');
  document.documentElement.classList.add('dark');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    <Analytics />
  </StrictMode>,
)
